import { Container, useBreakpointValue } from "@chakra-ui/react";
import Head from "next/head";

import Footer from "@/sections/home/Footer";
import Header from "@/sections/home/Header";
import { Content } from "@/sections/inmobiliarias/Content";

export default function Procesos() {
    const isGreaterThanMd = useBreakpointValue({ base: false, md: true });

    return (
        <>
            <Head>
                <title> Procesos | Grupo Guía </title>
                <link rel="canonical" href="https://grupoguia.mx/procesos" />
                <link rel="alternate" href="https://grupoguia.mx/procesos" hrefLang="es-mx" />
            </Head>
            <Header />
            <Container maxW="full" {...(isGreaterThanMd && { paddingInline: "0" })}>
                <Content />
                <Footer esGuiaRent={false} />
            </Container>
        </>
    );
}
